import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'pages.pick.maxQuantityDialog.title',
    defaultMessage: 'Items picked',
    description: 'Title of the max quantity packed dialog',
  },
  message: {
    id: 'pages.pick.maxQuantityDialog.message',
    defaultMessage: "You've already picked all the requested items.",
    description: 'Message of the max quantity picked dialog',
  },
  actions: {
    close: {
      id: 'actions.close',
      defaultMessage: 'Close',
      description: 'Label of the close action in the max quantity dialog',
    },
  },
};

export default defineMessages(translations);
